window.$crisp = [];
window.CRISP_WEBSITE_ID = "dda78ac2-2f60-4ce3-a378-0c2f4768db95";
(function() {
  d = document;
  s = d.createElement("script");
  s.src = "https://client.crisp.chat/l.js";
  s.async = 1;
  d.getElementsByTagName("head")[0].appendChild(s);
})();
